import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
export class ConditionsOrderedStep extends ConditionRegistryCategory {
    label = 'OrderedStep';
    constructor(parent) {
        super(parent);
        super.init();
    }
    step_correctlySelected = () => new ConditionRegistryItem({
        label: 'Step korrekt ausgewählt',
        eval: ({ orderedStep }) => !!orderedStep && orderedStep.stepEval.isNowCorrectlySelected,
    });
    step_wronglySelected = () => new ConditionRegistryItem({
        label: 'Step aktuell falsch ausgewählt',
        eval: ({ orderedStep }) => !!orderedStep && orderedStep.stepEval.isWronglySelected,
    });
    step_wrong = () => new ConditionRegistryItem({
        label: 'Step falsch abgeschlossen',
        eval: ({ orderedStep }) => !!orderedStep && orderedStep.stepEval.isWronglySelected && orderedStep.stepProgress.isStepCompleted,
    });
    step_temporaryFalseFeedback = () => new ConditionRegistryItem({
        label: 'OrderedStep 1.5s Temporäres "falsch" Feedback',
        eval: ({ orderedStep }) => !!orderedStep && orderedStep.stepUI.shouldShowTemporaryFalseFeedback_1500ms,
    });
    isLastStep = () => new ConditionRegistryItem({
        label: 'Is Last Step',
        eval: ({ step }) => step && step.task.steps[step.task.steps.length - 1] === step,
    });
    step_isCompleted = () => new ConditionRegistryItem({
        label: 'Step ist komplett',
        eval: ({ orderedStep }) => !!orderedStep && orderedStep.stepProgress.isStepCompleted,
    });
    orderedTaskStepIsComplete = () => new ConditionRegistryItem({
        label: 'Corresponding Step in Rolename is complete',
        eval: ({ at, orderedTask }) => {
            const step = getStep(at, orderedTask);
            return !!step && step.stepProgress.isStepCompleted;
        },
    });
    orderedTaskNthLocalItemTypeStepIsVisible = () => new ConditionRegistryItem({
        label: 'Corresponding Step in Rolename is visible',
        eval: ({ at, orderedTask }) => {
            const step = getStep(at, orderedTask);
            if (!step)
                return false;
            return step === orderedTask.step || step.stepProgress.isStepCompleted;
        },
    });
    orderedTaskNthLocalItemTypeStepIsCurrent = () => new ConditionRegistryItem({
        label: 'Corresponding Step in Rolename is current step',
        eval: ({ at, orderedTask }) => {
            const step = getStep(at, orderedTask);
            return !!step && step === orderedTask.step;
        },
    });
}
function getStep(at, orderedTask) {
    const stepName = at.actor.tags.find((role) => role.includes('step'));
    if (!stepName)
        return false;
    const nth = parseInt(stepName.split('step')[1]);
    if (!orderedTask || !orderedTask.steps)
        return false;
    if (orderedTask.steps.length < nth)
        return false;
    const step = orderedTask.steps[nth - 1];
    if (!step)
        return false;
    return step;
}
